import { combineReducers } from 'redux';
import * as _ from 'lodash';
import {
  FETCH_BANKS_SUCCESS,
  FETCH_CARDS_SUCCESS,
  FETCH_COMPANIES_SUCCESS,
  FETCH_TAGS,
  PATCH_TAGS,
} from './../constants';

function cards(state = [], action: any) {
  switch (action.type) {
    case FETCH_CARDS_SUCCESS:
      return state = action.data;
    default:
      return state;
  }
}

function banks(state = [], action: any) {
  switch (action.type) {
    case FETCH_BANKS_SUCCESS:
      return state = action.data;
    default:
      return state;
  }
}

function companies(state = [], action: any) {
  switch (action.type) {
    case FETCH_COMPANIES_SUCCESS:
      return state = action.data;
    default:
      return state;
  }
}

function tags(state = [], action: any) {
  switch (action.type) {
    case FETCH_TAGS:
      return state = action.data;
    case PATCH_TAGS: {
      const tt = state.filter((t: any) => t.id !== action.data.id);

      return _.orderBy(tt.concat(action.data), ['id'], ['desc']);
    }
    default:
      return state;
  }
}

const rootReducer = combineReducers({
  cards,
  banks,
  companies,
  tags,
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/reducers/index.ts